export enum AssetNumberType {
  Original = 'original',
  Temporary = 'temporary',
  Rental = 'rental',
}
